/**
 * Route for `trackerity-referral-partner-program`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { TrackerityReferralPartnerProgramPage } from "../features/trackerity-referral-partner-program/TrackerityReferralPartnerProgramPage";

export const trackerityReferralPartnerProgramRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/trackerity-referral-partner-program",
	component: TrackerityReferralPartnerProgramPage,
});

export default trackerityReferralPartnerProgramRoute;
